export default {
    lang: {
        name: 'Wishlist priority'
    }
}